<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  placeholder="Key in office name here"
                  append-icon="search"
                  label="Search Office Location"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-spacer />
              <v-col cols="2">
                <setup-office-locations-dialog-create
                  v-if="$hasPermissionTo([ 'create office locations'])"
                  @created="loadOfficeLocations"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="filteredOfficeLocations"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.company.name="{ item }">
              <div>
                <span v-if="item.company">
                  {{ item.company.name }}
                </span>
                <span v-else>N/A</span>
              </div>
            </template>

            <template v-slot:item.branch.branch_name="{ item }">
              <div>
                <span v-if="item.branch">
                  {{ item.branch.branch_name }}
                </span>
                <span v-else>N/A</span>
              </div>
            </template>

            <template v-slot:item.latitude="{ item }">
              <div>
                <span>
                  {{ item.latitude }}
                </span>
              </div>
            </template>

            <template v-slot:item.longitude="{ item }">
              <div>
                <span>
                  {{ item.longitude }}
                </span>
              </div>
            </template>
           
            <template v-slot:item.action="{ item }">
              <setup-office-locations-dialog-edit
                v-if="$hasPermissionTo([ 'update office locations'])"
                :office-location="item"
                @updated="loadOfficeLocations"
              />
            </template> -->
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupOfficeLocationsDialogEdit: () => import('@/components/setup/office-locations/DialogEdit'),
      SetupOfficeLocationsDialogCreate: () => import('@/components/setup/office-locations/DialogCreate'),
    },
    data () {
      return {
        officeLocations: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Company',
            align: 'left',
            value: 'company.name',
          },
          {
            text: 'Branch',
            align: 'left',
            value: 'branch.branch_name',
          },
          {
            text: 'Latitude',
            align: 'center',
            value: 'latitude',
            sortable: false,
          },
          {
            text: 'Longitude',
            align: 'center',
            value: 'longitude',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            align: 'center',
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
      }
    },
    computed: {
      filteredOfficeLocations () {
        return this.officeLocations.filter(officeLocation => {
          return officeLocation.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        })
      },
    },
    created () {
      this.loadOfficeLocations()
    },
    methods: {
      loadOfficeLocations () {
        this.$api.officeLocations().list()
          .then(res => {
            this.officeLocations = res.data

            this.tableLoading = false
          })
      },
    },
  }
</script>
